
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types'; // ES6
import { Radio } from 'antd';

import { PERIODE_MATI, PERIODE_MIGDIA, PERIODE_VESPRE } from '../../constants';
import { obtenirNomMoment } from '../commons/periodes';
import { selecioPeriodeObservacio } from '../../actions';

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
/**
 * Selector que permet fer el filtre entre els tres posibles periodes: Mati, Tarda, Vespre
 *
 */
class ObservacioSelectorPeriode extends Component {

    constructor(props) {
        super(props);

        this.onClickPeriode = this.onClickPeriode.bind(this);
    }

    /**
     * Event que es dispara quan es fa 'click' en un botó de periode
     * @param event
     */
    onClickPeriode(event) {
        const periodeSeleccionat = event.target.value;

        if (this.props.periodeActiu !== periodeSeleccionat) {
            this.props.selecioPeriodeObservacio(periodeSeleccionat);
        }
    }

    /**
     * Retorna la class 'active' en cas de estar seleccionat el periode.
     * @param value
     * @returns {string}
     */
    isActive(value) {
        return this.props.periodeActiu === value ? 'active' : '';
    }

    render() {
        if (!this.props.periodeActiu) {
            return <div></div>;
        }
        const horaMati = PERIODE_MATI[0];
        const horaMigdia = PERIODE_MIGDIA[0];
        const horaVespre = PERIODE_VESPRE[0];

        const nomMati = obtenirNomMoment(horaMati);
        const nomMigdia = obtenirNomMoment(horaMigdia);
        const nomVespre = obtenirNomMoment(horaVespre);

        return (
            <RadioGroup
                onChange={this.onClickPeriode}
                defaultValue={this.props.periodeActiu}>
                <RadioButton value={horaMati}>{nomMati}</RadioButton>
                <RadioButton value={horaMigdia}>{nomMigdia}</RadioButton>
                <RadioButton value={horaVespre}>{nomVespre}</RadioButton>
            </RadioGroup>
        );
    }
}

ObservacioSelectorPeriode.propTypes = {
    periodeActiu: PropTypes.string,
    selecioPeriodeObservacio: PropTypes.func
};

const mapStateToProps = (state) => ({
    periodeActiu: state.observacio.periodeSeleccionat
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        selecioPeriodeObservacio
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ObservacioSelectorPeriode);



// WEBPACK FOOTER //
// ./src/components/observacio/observacioSelectorPeriode.js